import { Tenant } from "./Types";
import ApiService from "./ApiService";

export const getTenants = async (signal?: AbortSignal): Promise<Tenant[]> => {
    const response = await ApiService.get<Tenant[]>({ url: `tenants`, signal });
    return response;
}

export const createTenant = async (payload: { name: string; description: string }, signal?: AbortSignal): Promise<{id: string}> => {
    const response = await ApiService.post<{id: string}>({ url: 'Tenants', data: payload, signal });
    return response;
}
